import React from 'react';
import { withRouter } from 'react-router-dom';
import SkeletonLoader from './Loaders/SkeletonLoader';

const SimpleSpinner = ({ location }) => {
    const pathname = location?.pathname || "";

    let skeletonType = "default";
    let count = 1;

    if (pathname.toLowerCase().includes("logout")) {
        skeletonType = "logout";
        count = 1;
    } else if (pathname.includes("checkout")) {
        skeletonType = "checkout";
        count = 1;
    } else if (pathname === "/product" || pathname === "/product/") {
        skeletonType = "product-detail";
        count = 1;
    } else if (pathname.includes("invoice")) {
        skeletonType = "invoice";
        count = 1;
    } else if (pathname.includes("listing") || pathname.includes("category")) {
        skeletonType = "product-listing";
        count = 1;
    } else if (pathname.includes("details")) {
        skeletonType = "account-details";
        count = 1;
    } else if (pathname.includes("addresses")) {
        skeletonType = "feature-card";
        count = 2;
    } else if (pathname.includes("wishlist")) {
        skeletonType = "wishlist";
        count = 1;
    } else if (pathname.includes("history")) {
        skeletonType = "account-history";
        count = 1;
    } else if (pathname === "/cart" || pathname === "/cart/") {
        skeletonType = "cart";
        count = 1;
    } else if (pathname.includes("login")) {
        skeletonType = "sign-in";
        count = 1;
    } else if (pathname.includes("register")) {
        skeletonType = "sign-up";
        count = 1;
    } else if (pathname.includes("reset_password")) {
        skeletonType = "forgot-password";
        count = 1;
    } else if (
        pathname.includes("pages/") ||
        pathname.includes("policies/") ||
        pathname.includes("about") ||
        pathname.includes("privacy") ||
        pathname.includes("refund") ||
        pathname.includes("shipping-policy")
    ) {
        skeletonType = "policy-page";
        count = 1;
    }

    return (
        <div style={{ width: '100%', minHeight: '70vh' }}>
            <SkeletonLoader type={skeletonType} count={count} />
        </div>
    );
};

export default withRouter(SimpleSpinner);
